import { jsxs as n, jsx as m, Fragment as a } from "react/jsx-runtime";
import { useTranslation as l } from "react-i18next";
import s from "./card-trailer.module.less.js";
import { convertMetersToKm as o } from "../../../../../helpers/number-helper.js";
const N = ({ trailer: e, onClick: t, notAvailable: c }) => {
  if (!e)
    return null;
  const { t: i } = l(), d = () => {
    typeof t == "function" && t();
  };
  return /* @__PURE__ */ n(
    "button",
    {
      className: [s.wrapper, c && s.notAvailable].join(" "),
      onClick: c ? void 0 : d,
      children: [
        /* @__PURE__ */ n("div", { children: [
          e.stationName && e.distanceInMeters && /* @__PURE__ */ n("p", { className: [s.nameAndDistance, "body-s"].join(" "), children: [
            o(e.distanceInMeters),
            " km (",
            e.stationName,
            ")"
          ] }),
          /* @__PURE__ */ m("p", { className: [s.title, "body-l bold"].join(" "), children: e.title }),
          /* @__PURE__ */ n("div", { className: [s.measurementsWrapper].join(" "), children: [
            /* @__PURE__ */ n("div", { className: s.measurementsItem, children: [
              /* @__PURE__ */ m("span", { className: [s.measurementsItemLabel, "eyebrow"].join(" "), children: i("TRAILER_RENTAL_TRAILER_MAX_LOAD") }),
              /* @__PURE__ */ n("span", { className: [s.measurementsItemValue, "body-s"].join(" "), children: [
                e.maxLoad,
                " kg"
              ] })
            ] }),
            /* @__PURE__ */ n("div", { className: s.measurementsItem, children: [
              /* @__PURE__ */ m("span", { className: [s.measurementsItemLabel, "eyebrow"].join(" "), children: i("TRAILER_RENTAL_TRAILER_TOTAL_WEIGHT") }),
              /* @__PURE__ */ n("span", { className: [s.measurementsItemValue, "body-s"].join(" "), children: [
                e.totalWeight,
                " kg"
              ] })
            ] }),
            (e?.measurements?.length || e.measurements?.width || e.measurements?.height) && /* @__PURE__ */ n("div", { className: s.measurementsItem, children: [
              /* @__PURE__ */ n("span", { className: [s.measurementsItemLabel, "eyebrow"].join(" "), children: [
                i("TRAILER_RENTAL_TRAILER_MEASUREMENTS_LABEL"),
                " ",
                e.measurements?.length && /* @__PURE__ */ m(a, { children: "L" }),
                " ",
                e?.measurements.width && /* @__PURE__ */ m(a, { children: "× B" }),
                " ",
                e.measurements?.height && /* @__PURE__ */ m(a, { children: " × H" })
              ] }),
              /* @__PURE__ */ n("span", { className: [s.measurementsItemValue, "body-s"].join(" "), children: [
                e.measurements?.length && /* @__PURE__ */ n(a, { children: [
                  e.measurements.length,
                  " "
                ] }),
                " ",
                e.measurements?.width && /* @__PURE__ */ n(a, { children: [
                  "× ",
                  e.measurements.width,
                  " "
                ] }),
                " ",
                e.measurements?.height && /* @__PURE__ */ n(a, { children: [
                  "× ",
                  e.measurements.height
                ] }),
                " cm"
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ n("div", { className: s.imageWrapper, children: [
          e.fromPrice && /* @__PURE__ */ m("div", { className: s.chip, children: /* @__PURE__ */ m("span", { className: [s.chipLabel, "body-s"].join(" "), children: i("TRAILER_RENTAL_TRAILER_FROM_PRICE_LABEL", { price: e.fromPrice }) }) }),
          /* @__PURE__ */ m("img", { className: s.trailerImage, src: e.image.url, alt: e.image.alt })
        ] }) }),
        c && /* @__PURE__ */ m("div", { className: s.notAvailableCover, children: /* @__PURE__ */ m("p", { className: [s.notAvailableMessage, "body-l bold"].join(" "), children: i("TRAILER_RENTAL_TRAILER_NOT_AVAILABLE") }) })
      ]
    }
  );
};
export {
  N as default
};
